import { createResourceContentSelector } from 'util/selector/resourceSelector';

import { ProjectSettingsModel } from 'api/dto/ProjectSettings.dto';
import { Resource } from 'model/Resource';
import { selectUserRoles } from 'reduxStore/auth/selectors';
import {
  selectCurrentKind,
  selectCurrentProject,
  selectIsLifecycleProject,
  selectProjectDomain,
} from 'reduxStore/project/projectSelector';
import { createSelector } from '@reduxjs/toolkit';
import { UserRoleType } from 'model/UserRoleType';
import { ProjectKind } from 'model/ProjectKind';

export const selectProjectSettingsResource = createSelector(
  selectProjectDomain,
  (domain) =>
    (domain && domain.settingsResource) || Resource.createPendingResource<ProjectSettingsModel>(),
);

export const selectProjectSettings = createResourceContentSelector(selectProjectSettingsResource);
export const selectIsSentimentAnalysisEnabled = createSelector(
  selectProjectSettings,
  selectIsLifecycleProject,
  (settings, isLifecycleProject) => settings?.sentimentAnalysis && !isLifecycleProject,
);

export const selectIsSentimentAnalysisEnabledCurrentProject = createSelector(
  selectCurrentProject,
  selectIsLifecycleProject,
  (currentProject, isLifecycleProject) =>
    currentProject?.settings?.sentimentAnalysis && !isLifecycleProject,
);

export const selectMinimalAmountOfClosedAnswers = createSelector(
  selectProjectSettings,
  (settings) => settings && settings.minimalAmountOfClosedAnswers,
);

export const selectIsDashboardNotificationsEnabled = createSelector(
  selectProjectSettings,
  (settings) => settings && settings.dashboardNotifications,
);

export const selectCanChangeSentimentAnalysis = createSelector(
  selectUserRoles,
  selectCurrentKind,
  (roles, kind) => {
    if (!roles.includes(UserRoleType.Admin) && !roles.includes(UserRoleType.CircleAdmin)) {
      return false;
    }

    const sentimentCompatibleKinds = [
      ProjectKind.PROJECT_ENGAGEMENT_SCORE,
      ProjectKind.PROJECT_OVERALL_SCORE,
      ProjectKind.PULSE_TEMPLATE,
    ];

    return sentimentCompatibleKinds.includes(kind);
  },
);

export const selectIsLifecycleSurveysEnabled = createSelector(
  selectProjectSettings,
  (settings) => settings && settings.lifecycleSurveys,
);
